import { ref } from "firebase/database";
import { listenDatabaseValue as onValue } from "../utils/listenDatabaseValue";
import { db } from "../lib/firebase";
import types from "../types";
import { normalizeAgencyIdsFromSnapshot } from "../utils/agenciesFeatureFlags";

import { LaunchError } from "../utils/errors";

export const startListenerAgenciesFeatureFlags = () => async (dispatch) => {
  try {
    const dbRef = ref(db, "agenciesFeatureFlags");
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val() ?? {};
      dispatch(
        setAgenciesFeatureFlags({
          importCampaigns: normalizeAgencyIdsFromSnapshot(data.importCampaigns),
          enterpriseOnlyPlans: normalizeAgencyIdsFromSnapshot(
            data.enterpriseOnlyPlans
          ),
          animateImageWithPrompt: normalizeAgencyIdsFromSnapshot(
            data.animateImageWithPrompt
          ),
        })
      );
    });
  } catch (error) {
    dispatch(
      LaunchError(error, false, [], {
        functionName: "startListenerAgenciesFeatureFlags",
        capture: "exception",
      })
    );
    console.log(error);
    return false;
  }
};

export const setAgenciesFeatureFlags = (data) => ({
  type: types.SET_AGENCIES_FEATURE_FLAGS,
  payload: data,
});
